<dashboardnav>
  <cradua-address-type-tbl [addresstypes]="addresstypes$ | async" (addresstype)="onSubmitAddressType($event)" (deleteAddressTypeEvent)="onDeleteAddressType($event)"
    *ngIf="(isLoadingAddressType$ | async ) === false">
  </cradua-address-type-tbl>

  <mrsoftapps-epims-reference-spinner *ngIf="(isLoadingAddressType$ | async) === true">
  </mrsoftapps-epims-reference-spinner>
  <!-- <pre>{{isLoading$ | async | json}}</pre> -->
</dashboardnav>
